import React from "react";
import PropTypes from "prop-types";
import useAuthStatus from "../../hooks/useAuthStatus";
import { connect } from "react-redux";

const AuthProvider = ({ children, auto_redirect }) => {
  const isAuthenticated = useAuthStatus();

  if (isAuthenticated) {
    window.location.replace(auto_redirect)
    return null; // return null to prevent rendering any content
  }

  return <>{children}</>;
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
  auto_redirect: PropTypes.string.isRequired
};


const mapStateToProps = (state) => ({
  auto_redirect: state.config.seaChange.auto_redirect,
});

export default connect(mapStateToProps, null)(AuthProvider);


// WEBPACK FOOTER //
// ./src/js/hocs/AuthProvider/authprovider.jsx